const toggleBtn = document.getElementById('galleryToggle')
const hiddenItems = document.querySelectorAll('.gallery-collapse')
let expanded = false

toggleBtn.addEventListener('click', () => {
	expanded = !expanded

	hiddenItems.forEach(item => {
		item.classList.toggle('expanded', expanded)

		if (expanded) {
			const img = item.querySelector('img[data-src]')
			if (img) {
				img.src = img.dataset.src
				img.loading = 'lazy'
				img.removeAttribute('data-src')
			}
		}
	})

	toggleBtn.textContent = expanded ? 'Zwiń galerię' : 'Pokaż więcej zdjęć'
})

;(function () {
	const items = document.querySelectorAll('.trainer__gallery-item')
	const lightbox = document.getElementById('galleryLightbox')
	const img = document.getElementById('lightboxImg')
	const caption = document.getElementById('lightboxCaption')
	const dotsContainer = document.getElementById('lightboxDots')

	// Czyta data-src jeśli obraz jeszcze nie załadowany
	const images = Array.from(items).map(item => ({
		src: item.querySelector('img').dataset.src || item.querySelector('img').src,
		alt: item.querySelector('img').alt,
		label: item.querySelector('span')?.textContent || '',
	}))

	let current = 0
	let touchStartX = 0
	let touchStartY = 0

	document.body.appendChild(lightbox)

	function buildDots() {
		dotsContainer.innerHTML = ''
		images.forEach((_, i) => {
			const btn = document.createElement('button')
			btn.className = 'gallery-lightbox__dot' + (i === current ? ' is-active' : '')
			btn.setAttribute('aria-label', `Zdjęcie ${i + 1}`)
			btn.addEventListener('click', () => goTo(i))
			dotsContainer.appendChild(btn)
		})
	}

	function goTo(index) {
		current = (index + images.length) % images.length

		img.style.transition = 'opacity 0.25s ease'
		img.style.opacity = '0'

		setTimeout(() => {
			const newImg = new Image()
			newImg.onload = () => {
				img.src = newImg.src
				img.alt = images[current].alt
				img.style.opacity = '1'
			}
			newImg.src = images[current].src
		}, 250)

		caption.style.opacity = '0'
		setTimeout(() => {
			caption.textContent = images[current].label
			caption.style.opacity = '1'
		}, 250)

		document.querySelectorAll('.gallery-lightbox__dot').forEach((d, i) => {
			d.classList.toggle('is-active', i === current)
		})
	}

	function open(index) {
		current = index

		// Jeśli obraz jeszcze nie załadowany (data-src), załaduj go teraz
		const clickedImg = items[index].querySelector('img')
		if (clickedImg.dataset.src) {
			images[index].src = clickedImg.dataset.src
			clickedImg.src = clickedImg.dataset.src
			clickedImg.removeAttribute('data-src')
		}

		buildDots()
		goTo(current)
		lightbox.classList.add('is-open')
		document.body.style.overflow = 'hidden'
		document.getElementById('lightboxClose').focus()
	}

	function close() {
		lightbox.classList.remove('is-open')
		document.body.style.overflow = ''
	}

	lightbox.addEventListener(
		'touchstart',
		e => {
			touchStartX = e.changedTouches[0].clientX
			touchStartY = e.changedTouches[0].clientY
		},
		{ passive: true },
	)

	lightbox.addEventListener(
		'touchend',
		e => {
			const dx = e.changedTouches[0].clientX - touchStartX
			const dy = e.changedTouches[0].clientY - touchStartY
			if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
				dx < 0 ? goTo(current + 1) : goTo(current - 1)
			}
		},
		{ passive: true },
	)

	items.forEach((item, i) => {
		item.addEventListener('click', () => open(i))
		item.setAttribute('tabindex', '0')
		item.setAttribute('role', 'button')
		item.setAttribute('aria-label', `Otwórz zdjęcie: ${images[i].label}`)
		item.addEventListener('keydown', e => {
			if (e.key === 'Enter' || e.key === ' ') open(i)
		})
	})

	document.getElementById('lightboxClose').addEventListener('click', close)
	document.getElementById('lightboxPrev').addEventListener('click', () => goTo(current - 1))
	document.getElementById('lightboxNext').addEventListener('click', () => goTo(current + 1))

	lightbox.addEventListener('click', e => {
		if (e.target === lightbox) close()
	})

	document.addEventListener('keydown', e => {
		if (!lightbox.classList.contains('is-open')) return
		if (e.key === 'Escape') close()
		if (e.key === 'ArrowLeft') goTo(current - 1)
		if (e.key === 'ArrowRight') goTo(current + 1)
	})
})()